import z from "zod"
import { BigBlueIntegrationResponseDataSchema } from "./response_data"

export function areBigBlueWebhooksWorking(
  integration: z.infer<typeof BigBlueIntegrationResponseDataSchema> | null | undefined,
) {
  return Boolean(
    integration?.token &&
    integration?.prefix &&
    integration?.webhooksSecretKey &&
    integration?.webhooksVerifiedAt,
  )
}
